var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 11.454,
    viewBox: "0 0 24 11.454",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1628.619 -1313.416)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1628.619 1313.416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1651.9,1319.667c-4.7-3.86-9.273-5.555-13.577-5.031a14.029,14.029,0,0,0-8.8,4.932l-.9-.674a14.922,14.922,0,0,1,9.554-5.376c4.629-.564,9.489,1.209,14.446,5.277Z",
    transform: "translate(-1628.619 -1313.416)",
    fill: "#0d1c4b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1634.85 1313.592)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.639,
    cy: 5.639,
    r: 5.639,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1665.259,1325.569a5.639,5.639,0,1,1,5.639-5.639A5.646,5.646,0,0,1,1665.259,1325.569Zm0-10.15a4.511,4.511,0,1,0,4.511,4.511A4.516,4.516,0,0,0,1665.259,1315.419Z",
    transform: "translate(-1659.62 -1314.291)",
    fill: "#0d1c4b"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1638.233 1316.975)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.256,
    cy: 2.256,
    r: 2.256,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1678.709,1335.637a2.256,2.256,0,1,1,2.256-2.256A2.258,2.258,0,0,1,1678.709,1335.637Zm0-3.384a1.128,1.128,0,1,0,1.128,1.128A1.129,1.129,0,0,0,1678.709,1332.253Z",
    transform: "translate(-1676.454 -1331.125)",
    fill: "#0d1c4b"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.6314e22397a9fe9c5e649dbd2dd318f5.svg";
export { ForwardRef as ReactComponent };